import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NetzbetreiberListComponent } from './netzbetreiber-list/netzbetreiber-list.component';
import { MaterialModule } from '../common/material/material.module';
import { NetzbetreiberDetailComponent } from './netzbetreiber-detail/netzbetreiber-detail.component';
import { NetzbetreiberPageComponent } from './netzbetreiber-page/netzbetreiber-page.component';
import { AppRoutingModule } from '../app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GlobalDirectivesModule } from '../common/formvalidation/global-directives.module';
import { ServiceModule } from '../service/service.module';
import { AvailableStadtwerkeIdDirective } from './directives/available-stadtwerkeId.directive';
import {
    UniqueTeilgebietAndNetzbetreibernummerDirective,
} from './directives/unique-teilgebiet-and-netzbetreibernummer.directive';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        GlobalDirectivesModule,
        ServiceModule,
    ],
    declarations: [
        NetzbetreiberListComponent,
        NetzbetreiberDetailComponent,
        NetzbetreiberPageComponent,
        AvailableStadtwerkeIdDirective,
        UniqueTeilgebietAndNetzbetreibernummerDirective,
    ],
})
export class NetzbetreiberModule {
}
